import './App.css';
import { BrowserRouter, Route, Switch} from 'react-router-dom'
import { useEffect} from 'react'
import { userLoginCheck, useUserDispatch, useUserState } from './context'
import { LoginPage } from './pages/LoginPage'
import { MainPage} from './pages/MainPage'
import { LogoutPage } from './pages/LogoutPage';


function App() {
  const { logined } = useUserState()
  const userDispatch = useUserDispatch()

  useEffect( () => {
    console.log("logined : " + logined)
    if( logined === "unknown" ){
      userLoginCheck(userDispatch)
    }
  }, [])

  console.log("logined : " + logined)
  if( logined === "unknown"){
    return(
      <div className="AppLoading">
        Loading for Login Check
      </div>
    )
  }else{
    return(
      <BrowserRouter>
        <Switch>
          <Route exact path="/login" component={LoginPage}></Route>
          <Route exact path="/logout" component={LogoutPage}></Route>
          <Route path="/" component={MainPage}></Route>
        </Switch>
      </BrowserRouter>
    )
  }

}

export default App;
